export default __webpack_public_path__ + "static/media/PersImg29.09bb35d9.jpg";